module.exports = __webpack_public_path__ + "img/pocketScreen.316ce1a7.png";